export const permissionsMixin = {
  methods: {
    hasAccessPermission(key, permissions) {
      const permissionsList =
        permissions ?? this.$store.state?.userInfo?.permissions;
      if(permissionsList.length == 0){
        return true;
      }
      return permissionsList?.includes(key) ?? false;
    },
  },
  computed: {},
};
